import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _Object$keys from 'babel-runtime/core-js/object/keys';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import request from 'superagent';

import ResponseWrapper from '../response';
import GenericResource from '../base';
import { isArray, isObject } from '../typeChecks';

export var SuperagentResponse = function (_ResponseWrapper) {
    _inherits(SuperagentResponse, _ResponseWrapper);

    function SuperagentResponse() {
        _classCallCheck(this, SuperagentResponse);

        return _possibleConstructorReturn(this, (SuperagentResponse.__proto__ || _Object$getPrototypeOf(SuperagentResponse)).apply(this, arguments));
    }

    _createClass(SuperagentResponse, [{
        key: 'status',
        get: function get() {
            return this.response.status;
        }
    }, {
        key: 'statusType',
        get: function get() {
            return this.response.statusType;
        }
    }, {
        key: 'text',
        get: function get() {
            return this.response.text;
        }
    }, {
        key: 'data',
        get: function get() {
            // Return text if response is of type text/*
            if (this.response.type.startsWith('text/')) {
                return this.text;
            }

            return this.response.body || this.text;
        }
    }, {
        key: 'headers',
        get: function get() {
            return this.response.header;
        }
    }]);

    return SuperagentResponse;
}(ResponseWrapper);

export var SuperAgentResource = function (_GenericResource) {
    _inherits(SuperAgentResource, _GenericResource);

    function SuperAgentResource() {
        _classCallCheck(this, SuperAgentResource);

        return _possibleConstructorReturn(this, (SuperAgentResource.__proto__ || _Object$getPrototypeOf(SuperAgentResource)).apply(this, arguments));
    }

    _createClass(SuperAgentResource, [{
        key: 'createRequest',
        value: function createRequest(method, url, query, data, attachments, requestConfig) {
            // eslint-disable-line class-methods-use-this
            method = method.toLowerCase();

            var req = request[method](url);

            if (this.config(requestConfig).withCredentials) {
                req = req.withCredentials();
            }

            if (query) {
                req = req.query(query);
            }

            // If attachments are used construct a multipart request
            if (attachments) {
                attachments.forEach(function (attachment) {
                    req = req.attach(attachment.field, attachment.file, attachment.name);
                });

                // Set all the fields
                _Object$keys(data).forEach(function (fieldKey) {
                    var value = data[fieldKey];

                    // Future: Make this logic configurable
                    if (value !== null && value !== undefined) {
                        if (isArray(value)) {
                            // Send arrays as multipart arrays
                            value.forEach(function (fValue) {
                                req = req.field(fieldKey + '[]', fValue);
                            });
                        } else if (isObject(value)) {
                            // Posting objects as field contents is not supported by superagent
                            //  to work around this we just jsonify them
                            req = req.field(fieldKey, _JSON$stringify(value));
                        } else {
                            // Convert values via their toString
                            req = req.field(fieldKey, '' + value);
                        }
                    }
                });
            } else {
                req = req.send(data);
            }

            return req;
        }
    }, {
        key: 'doRequest',
        value: function doRequest(req, resolve) {
            // eslint-disable-line class-methods-use-this
            req.end(function (err, res) {
                resolve(res, err);
            });
        }
    }, {
        key: 'setHeader',
        value: function setHeader(req, key, value) {
            // eslint-disable-line class-methods-use-this
            return req.set(key, value);
        }
    }], [{
        key: 'wrapResponse',
        value: function wrapResponse(response, error, req) {
            // eslint-disable-line no-unused-vars
            // For superagent, all 4XX/5XX response codes also return an error object. Since
            // tg-resources handles these errors in the GenericResource we need to only send
            // error object here if it is not due to a response code.
            //
            // Network errors in superagent don't have `err.status`
            return new SuperagentResponse(response, error && error.status === undefined ? error : null);
        }
    }]);

    return SuperAgentResource;
}(GenericResource);